import request from '../request.js'

// 保存/修改角色菜单按钮信息（张卫华）
const saveOrUpdateRoleMenuBtn = function (data) {
    return request({
        url: 'sysGroupRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}
// 获取已选中按钮信息
const getCheckedBtn = function (data) {
    return request({
        url: 'sysGroupRoleMenuBtn/getCheckedBtn',
        method: 'post',
        data
    })
}

// 获取限定按钮信息
const getLimitBtn = function (data) {
    return request({
        url: 'sysGroupRoleMenuBtn/getLimitBtn',
        method: 'post',
        data
    })
}
// 根据菜单id,获取按钮信息；根据角色id,菜单id,获取已选中的按钮信息（郑志会）
const getBtns = function (data) {
    return request({
        url: '/sysBtn/getGroupRoleMenuBtn',
        method: 'post',
        data
    })
}
// 根据菜单id,获取按钮信息；根据角色id,菜单id,获取已选中的按钮信息（郑志会）
const saveOrUpdateBtn = function (data) {
    return request({
        url: '/sysGroupRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}
export {
    saveOrUpdateRoleMenuBtn,
    getCheckedBtn,
    getLimitBtn,
    getBtns,
    saveOrUpdateBtn
}